import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';

export const PopupContainer = styled(Box)(() => ({
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '552px',
  height: '252px',
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
  padding: '16px',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column',
}));

export const PopupHeader = styled(Typography)(() => ({
  fontWeight: 'bold',
  fontSize: '20px',
  marginBottom: '8px',
}));

export const PopupBody = styled(Typography)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignContent: 'center',
  alignItems: 'center',
  marginBottom: '16px',
  height: 'auto',
}));

export const PopupActions = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

export const PopupButton = styled(Button)(() => ({
  marginLeft: '8px',
  width: '150px',
  height: '40px',
}));
